// actions/authActions.js

export const SET_ENGAGEMENT_TIME = 'SET_ENGAGEMENT_TIME';

export const loginUser = (token) => {
  const user = token.extension_Role;
  //set organization id
  return {
    type: "LOGIN_USER",
    payload: { token, user },
  };
};

export const logoutUser = () => {
  return {
    type: "LOGOUT_USER",
  };
};

export const saveToken = (apiToken) => {
  return {
    type: "SAVE_TOKEN",
    payload: { apiToken },
  };
};

export const refreshToken = () => {
  return {
    type: "MSAL_INSTANCE",
  };
};

export const setEngagementTime = (engagementTime, chatId) => {
  console.log('Setting engagement time:', engagementTime, 'forChatId', chatId);
  return {
    type: SET_ENGAGEMENT_TIME,
    payload:  { engagementTime, chatId },
  };
};
